/* eslint-disable */
import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import template from '@bingads-webui-campaign-legacy/adextension-shared/template/store-hour.pug';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextension/shared');
var View = Backbone.View.extend({
  initialize: function (options) {
    this.options = _.extend({}, options);
    this.viewModel = {
      isExpanded: ko.observable(options.model.length > 0)
    };
  },
  render: function () {
    var self = this;
    self.$el.html(template({
      i18n: i18n,
      labelClass: self.options.labelClass || 'col-sm-4',
      model: self.options.model
    }));
    ko.applyBindings(this.viewModel, self.el);
    self.$('#scheduling').on('show.bs.collapse', function () {
      self.$('.expanderImage').toggleClass('expanderImage expandedImage');
    });
    self.$('#scheduling').on('hide.bs.collapse', function () {
      self.$('.expandedImage').toggleClass('expanderImage expandedImage');
    });
    return self;
  },
  events: {
    'show.bs.collapse': 'show',
    'hide.bs.collapse': 'hide'
  },
  show: function () {
    this.viewModel.isExpanded(true);
  },
  hide: function () {
    this.viewModel.isExpanded(false);
  }
});
export default View;

